module.exports = __webpack_public_path__ + "img/Inflammation-PDAC_GSE202740.8b488e1a.png";